import React,{useState, useEffect} from 'react'
import './AdvertiserDetails.css';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
import { useNavigate, useSearchParams } from 'react-router-dom';
import leftChevron from '../../../../assets/images/leftChevron.png';
import { useParams } from 'react-router';
import { getAdvertiserDetails } from '../../../../services/getAdvertiserDetails';
import { getAdvertiserCategories } from '../../../../services/getAdvertisementCategories';
import { createAdvertiserCategory } from '../../../../services/createAdvertiserCategory';
import { deleteAdvertiserCategory } from '../../../../services/deleteAdvertiserCategory';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import ToggleButton from 'react-toggle-button'
import { toggleAdvertiserActive } from '../../../../services/toggleAdvertiserActive';
import { toggleAdvertisment } from '../../../../services/toggleAdvertisement';
import { updateAdvertiser } from '../../../../services/advertiserAPI';
import Select from 'react-select';
import ReactJsAlert from "reactjs-alert";
import {
  formatAdminCampaignPaymentStatus,
  isUnpaidCampaignStatus,
} from '../../../../utils/adminCampaignPaymentStatus';

export default function AdvertiserDetails() {
  const [advertiserData, setAdvertiserData] = useState({ advertiser: {}, campaigns: [] })
  const [accountActive, setAccountActive] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [allCategories, setAllCategories] = useState([]);
  const token = useSelector(getToken);
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [isEditing, setIsEditing] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [editData, setEditData] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [selectedEditCategory, setSelectedEditCategory] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editError, setEditError] = useState(false);
  const [editErrorCode, setEditErrorCode] = useState("");
  const [editSuccess, setEditSuccess] = useState(false);
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  
  function getAllCategories(catId) {
    getAdvertiserCategories(token).then(result => {
      let options = [];
      result.data.categories.forEach(category => {
        options.push({label: category.CategoryName, value: category.CategoryId});
      });
      setAllCategories(options);
      if (catId) {
        const category = result.data.categories?.find(cat => cat.CategoryId === catId);
        setCategoryName(category?.CategoryName || "Unknown");
        const sel = options.find(o => o.value === catId);
        if (sel) {
          setSelectedEditCategory(sel);
          setEditData(prev => ({ ...prev, categoryId: sel.value }));
        }
      }
    }).catch(e => {
      setCategoryName("Error loading categories");
    })
  }

  function onAddCategory() {
    const name = window.prompt('New category name');
    if (!name || name.trim() === '') return;
    createAdvertiserCategory(name.trim(), token).then(r => {
      // refresh and preselect
      getAdvertiserCategories(token).then(result => {
        let options = [];
        result.data.categories.forEach(category => {
          options.push({label: category.CategoryName, value: category.CategoryId});
        });
        setAllCategories(options);
        const createdId = r.data && r.data.categoryId ? parseInt(r.data.categoryId, 10) : null;
        if (createdId) {
          const sel = options.find(o => parseInt(o.value,10) === parseInt(createdId,10));
          if (sel) {
            setSelectedEditCategory(sel);
            setEditData({ ...editData, categoryId: sel.value });
          }
        }
      });
    }).catch(err => {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setEditError(true);
        setEditErrorCode(err.response.data.message);
      } else {
        setEditError(true);
        setEditErrorCode('Failed to create category');
      }
    })
  }

  function onDeleteCategory() {
    if (!selectedEditCategory) {
      setEditError(true);
      setEditErrorCode('Select a category to delete');
      return;
    }
    if (!window.confirm(`Delete category '${selectedEditCategory.label}'? This cannot be undone if in use.`)) return;
    deleteAdvertiserCategory(selectedEditCategory.value, token).then(() => {
      // refresh
      getAllCategories();
      setSelectedEditCategory(null);
      setEditData({ ...editData, categoryId: "" });
    }).catch(err => {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setEditError(true);
        setEditErrorCode(err.response.data.message);
      } else {
        setEditError(true);
        setEditErrorCode('Failed to delete category');
      }
    })
  }
  
  function getAdvDetails() {
    getAdvertiserDetails(token, id).then(response => {
      setAdvertiserData(response.data || { advertiser: {}, campaigns: [] });
      setAccountActive(response.data?.advertiser?.Active)
      // Fetch categories after getting advertiser data
      getAllCategories(response.data?.advertiser?.CategoryId);
      // Initialize edit data with current advertiser data
      initializeEditData(response.data?.advertiser);
    })
}

  function initializeEditData(advertiser) {
    if (advertiser) {
      const initialEditData = {
        fname: advertiser.Fname || "",
        lname: advertiser.Lname || "",
        companyName: advertiser.CompanyName || "",
        email: advertiser.Email || "",
        categoryId: advertiser.CategoryId || "",
        slotCost: advertiser.SlotCost !== undefined ? advertiser.SlotCost : "",
        active: advertiser.Active || false,
        password: ""
      };
      setEditData(initialEditData);
      setOriginalData(initialEditData);
    }
  }

 useEffect(() => {
   getAdvDetails();
   // Check if tab=edit query param is present
   const tab = searchParams.get('tab');
   if (tab === 'edit') {
     setSelectedTabIndex(2);
   } else {
     setSelectedTabIndex(0);
   }
   return () => {
     
   }
 }, [token, id, searchParams])
 
  function convertGMTtoLocalDatetime(gmtDatetimeString) {
    const gmtDate = new Date(gmtDatetimeString);
    const localDatetime = gmtDate.toLocaleString(undefined, {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      hour12: false,
    });
    return localDatetime;
  }

  function getCampaignStatus(statusId) {
    if (statusId === 1) return 'Active';
    if (statusId === 2) return 'Inactive';
    if (statusId === 3) return 'Pending';
    return 'Unknown';
  }

  function formatCurrency(value) {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }
    return currencyFormatter.format(Number(value));
  }

  function toggleAdvertiserStatus(newStatus) {
    let formatted = '';
    if (newStatus) {
      formatted= '1'
    }
    else {
      formatted = '0'
    }
    toggleAdvertiserActive(token, advertiserData?.advertiser?.AdvertiserId,formatted).then(response=> {
      setAccountActive(newStatus);
      getAdvDetails();

    })
  }
  function toggleAdvertisementStatus(newStatus, adId) {
    let formatted = '';
    if (newStatus) {
      formatted = '1'
    }
    else {
      formatted = '2'
    }
    toggleAdvertisment(token, adId, formatted).then(response => {
      getAdvDetails();

    })
  }

  function handleEditCategoryChange(selectedOption) {
    setSelectedEditCategory(selectedOption);
    if (selectedOption) {
      setEditData({ ...editData, categoryId: selectedOption.value });
    } else {
      setEditData({ ...editData, categoryId: "" });
    }
  }

  function handleEditFieldChange(fieldName, value) {
    setEditData({ ...editData, [fieldName]: value });
  }

  function handleEditSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    setEditError(false);
    setEditErrorCode("");

    // Build update payload with only changed fields + advertiserId
    const updatePayload = { advertiserId: id };
    let hasChanges = false;

    if (editData.fname !== originalData.fname) {
      updatePayload.fname = editData.fname;
      hasChanges = true;
    }
    if (editData.lname !== originalData.lname) {
      updatePayload.lname = editData.lname;
      hasChanges = true;
    }
    if (editData.companyName !== originalData.companyName) {
      updatePayload.companyName = editData.companyName;
      hasChanges = true;
    }
    if (editData.email !== originalData.email) {
      updatePayload.email = editData.email;
      hasChanges = true;
    }
    if (editData.categoryId !== originalData.categoryId) {
      updatePayload.categoryId = editData.categoryId;
      hasChanges = true;
    }
    if (editData.slotCost !== originalData.slotCost) {
      if (editData.slotCost === "" || isNaN(parseFloat(editData.slotCost)) || parseFloat(editData.slotCost) < 0) {
        setEditError(true);
        setEditErrorCode("Slot Cost must be a valid number greater than or equal to 0");
        setIsSubmitting(false);
        return;
      }
      updatePayload.slotCost = parseFloat(editData.slotCost);
      hasChanges = true;
    }
    if (editData.active !== originalData.active) {
      updatePayload.active = editData.active;
      hasChanges = true;
    }
    if (editData.password && editData.password !== "") {
      updatePayload.password = editData.password;
      hasChanges = true;
    }

    if (!hasChanges) {
      setEditError(true);
      setEditErrorCode("No changes to save");
      setIsSubmitting(false);
      return;
    }

    updateAdvertiser(id, updatePayload, token).then(response => {
      setEditSuccess(true);
      setIsSubmitting(false);
      // Refresh data after 1.5 seconds
      setTimeout(() => {
        getAdvDetails();
        setSelectedTabIndex(0);
        setIsEditing(false);
      }, 1500);
    }).catch(e => {
      setEditError(true);
      setEditErrorCode(e.message || "Failed to update advertiser");
      setIsSubmitting(false);
    });
  }

  function handleEditCancel() {
    setSelectedTabIndex(0);
    setIsEditing(false);
    setEditData(originalData);
    setEditError(false);
    setEditSuccess(false);
    setSelectedEditCategory(null);
  }
  return (
    <div>
      <ReactJsAlert
        status={editError}
        type={"error"}
        title={"Edit Failed"}
        quotes={true}
        quote={editErrorCode}
        Close={() => setEditError(false)}
        color="#1E1E1E"
      />
      <ReactJsAlert
        status={editSuccess}
        type={"success"}
        title={"Advertiser Updated"}
        quotes={false}
        Close={() => setEditSuccess(false)}
        color="#1E1E1E"
      />
      <div className='backContainer'>
      <img className='leftChevronAdvertiserDetails' onClick={() => { navigate('/adminDashboard/advertisers/home') }} src={leftChevron} />

      <span className='advertiserCompanyTitle'>{advertiserData?.advertiser?.CompanyName}</span>
      </div>
      <Tabs selectedIndex={selectedTabIndex} onSelect={(index) => setSelectedTabIndex(index)}>
        <TabList>
          <Tab>User Details</Tab>
          <Tab>Campaigns</Tab>
          <Tab>Edit</Tab>
        </TabList>
        <TabPanel>

          <span className='tabTitle'>User Details</span>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Id</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.AdvertiserId}</span>
        </div>
        <div className='userDetailsItem'>
        
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>First Name</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.Fname}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Last Name</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.Lname}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Company Name</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.CompanyName}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Category</span>
          <span className='userDetailsData'>{categoryName}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Account Created Date</span>
          <span className='userDetailsData'>{convertGMTtoLocalDatetime(advertiserData?.advertiser?.CreatedDate)}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Email</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.Email}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Phone</span>
          <span className='userDetailsData'>
            {advertiserData?.advertiser?.PhoneNumber
              ? String(advertiserData.advertiser.PhoneNumber).trim()
              : '—'}
          </span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Slot Cost</span>
          <span className='userDetailsData'>{advertiserData?.advertiser?.SlotCost !== undefined && advertiserData?.advertiser?.SlotCost !== null ? currencyFormatter.format(advertiserData?.advertiser?.SlotCost) : 'N/A'}</span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Account Activated</span>
          <span className='userDetailsData'>
            {advertiserData?.advertiser?.AccountActivated ? 'Yes' : 'No'}
            {advertiserData?.advertiser?.TosAcceptedAt && (
              <> — TOS accepted {convertGMTtoLocalDatetime(advertiserData.advertiser.TosAcceptedAt)}</>
            )}
            {advertiserData?.advertiser?.TosVersion && (
              <> (version {advertiserData.advertiser.TosVersion})</>
            )}
          </span>
        </div>
        <div className='userDetailsItem'>
          <span className='userDetailsTitle'>Account Status</span>
            <span className='userDetailsData'>{accountActive && 'Active'}{!accountActive && 'Inactive'}</span>
            <ToggleButton
              value={accountActive || false}
              onToggle={(value) => {
                toggleAdvertiserStatus(!value);
              }} />
          </div>
        </TabPanel>
        <TabPanel>

          <div className="advertiserCampaignsTabHeader">
            <span className='tabTitle'>Campaign Subscriptions</span>
            <button
              type="button"
              className="approveBtn userDetailsBtn"
              onClick={() => navigate(`/adminDashboard/advertisers/details/${id}/createCampaign`)}
            >
              Create campaign
            </button>
          </div>
          <table className='adminDashboardScreensTable'>
            <thead>
              <tr>
                <th>Preview</th>
                <th>Id</th>
                <th>Name</th>
                <th>Placement</th>
                <th>Monthly Fee</th>
                <th>Payment</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {advertiserData?.campaigns?.map(campaign => (
                <tr onClick={() => { navigate('/adminDashboard/advertisers/campaignDetails', { state: { adId: campaign.AdvertisementId } })}} key={campaign.AdvertisementId}>
                  <td>
                    {campaign.AdContentHorizontal ? (
                      <img
                        className='campaignListThumb'
                        src={campaign.AdContentHorizontal}
                        alt='Campaign creative'
                      />
                    ) : (
                      '—'
                    )}
                  </td>
                  <td>{campaign.AdvertisementId}</td>
                  <td>{campaign.AdvertisementName}</td>
                  <td>
                    <span className='slotBadge'>
                      Automatic
                    </span>
                  </td>
                  <td>{formatCurrency(campaign.MonthlyFee)}</td>
                  <td>
                    <span
                      className={
                        isUnpaidCampaignStatus(campaign.SubscriptionStatus)
                          ? 'campaignPaymentBadge unpaid'
                          : 'campaignPaymentBadge paid'
                      }
                    >
                      {formatAdminCampaignPaymentStatus(campaign.SubscriptionStatus)}
                    </span>
                  </td>
                  <td>{getCampaignStatus(campaign.StatusId)} {(campaign.StatusId == 1 || campaign.StatusId == 2) && <ToggleButton className="toggleBtn"
                    value={campaign.StatusId == 1}
                    onToggle={(value) => {
                      toggleAdvertisementStatus(!value, campaign.AdvertisementId);
                    }} />}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabPanel>
        <TabPanel>
          <span className='tabTitle'>Edit Advertiser</span>
          <form onSubmit={handleEditSubmit} className='advertiserRegisterContainer'>
            <div className='advertiserRegisterItemfull'>
              <span className='advertiserRegisterItemTitle'>Advertiser Full Company Name</span>
              <input 
                max={50} 
                onChange={(e) => { handleEditFieldChange("companyName", e.nativeEvent.target.value) }} 
                className='advertiserRegisterItemInput' 
                placeholder='Advertiser Full Company Name' 
                type={"text"}
                value={editData.companyName || ""}
              />
            </div>
            <div className='advertiserRegisterItemfull'>
              <span className='advertiserRegisterItemTitle'>Category</span>
              <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <div style={{flex: 1}}>
                  <Select 
                    value={allCategories.find(cat => cat.value === editData.categoryId) || null}
                    onChange={handleEditCategoryChange}
                    isMulti={false}
                    options={allCategories}
                    placeholder='Select Category'
                  />
                </div>
                <button type="button" className='advertiserSmallBtn' onClick={onAddCategory}>+ Add</button>
                <button type="button" className='advertiserSmallBtn danger' onClick={onDeleteCategory}>Delete</button>
              </div>
            </div>
            <div className='advertiserRegisterItemhalfright'>
              <span className='advertiserRegisterItemTitle'>First Name</span>
              <input 
                max={50}
                onChange={(e) => { handleEditFieldChange("fname", e.nativeEvent.target.value) }}
                className='advertiserRegisterItemInput'
                placeholder='First Name'
                type={"text"}
                value={editData.fname || ""}
              />
            </div>
            <div className='advertiserRegisterItemhalfleft'>
              <span className='advertiserRegisterItemTitle'>Last Name</span>
              <input
                max={50}
                onChange={(e) => { handleEditFieldChange("lname", e.nativeEvent.target.value) }}
                className='advertiserRegisterItemInput'
                placeholder='Last Name'
                type={"text"}
                value={editData.lname || ""}
              />
            </div>
            <div className='advertiserRegisterItemhalfright'>
              <span className='advertiserRegisterItemTitle'>Email</span>
              <input
                max={100}
                onChange={(e) => { handleEditFieldChange("email", e.nativeEvent.target.value) }}
                className='advertiserRegisterItemInput'
                placeholder='Email'
                type={"email"}
                value={editData.email || ""}
              />
            </div>
            <div className='advertiserRegisterItemhalfleft'>
              <span className='advertiserRegisterItemTitle'>Slot Cost</span>
              <input
                min={0}
                step="0.01"
                onChange={(e) => { handleEditFieldChange("slotCost", e.nativeEvent.target.value) }}
                className='advertiserRegisterItemInput'
                placeholder='0.00'
                type={"number"}
                value={editData.slotCost || ""}
              />
            </div>
            <div className='advertiserRegisterItemhalfright'>
              <span className='advertiserRegisterItemTitle'>Active</span>
              <ToggleButton
                value={editData.active || false}
                onToggle={(value) => {
                  handleEditFieldChange("active", !value);
                }}
              />
            </div>
            <div className='advertiserRegisterItemhalfleft'>
              <span className='advertiserRegisterItemTitle'>Password (optional - leave empty to keep current)</span>
              <input
                max={50}
                onChange={(e) => { handleEditFieldChange("password", e.nativeEvent.target.value) }}
                className='advertiserRegisterItemInput'
                placeholder='New password'
                type={"password"}
                value={editData.password || ""}
              />
            </div>
            <div className='advertiserEditFormBtnContainer'>
              <input 
                type={"submit"} 
                className='advertiserEditFormBtn'
                value={isSubmitting ? 'Saving...' : 'Save Changes'}
                disabled={isSubmitting}
              />
              <button
                type="button"
                onClick={handleEditCancel}
                className='advertiserEditCancelBtn'
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </div>
          </form>
        </TabPanel>
      </Tabs>
    </div>
  )
}
